import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorVotingVoucher = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="m20.25.75.06.364a2.77 2.77 0 0 0 2.19 2.261 2.77 2.77 0 0 0-2.19 2.261L20.25 6l-.058-.348A2.798 2.798 0 0 0 18 3.375a2.77 2.77 0 0 0 2.19-2.261l.06-.364Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="m21.75 6 .008.06c.049.378.36.668.742.69l-.029.005a.895.895 0 0 0-.721.745.834.834 0 0 0-.682-.738L21 6.75a.79.79 0 0 0 .747-.717L21.75 6Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M2.25 17c0-.966.784-1.75 1.75-1.75h15c.966 0 1.75.784 1.75 1.75v2A1.75 1.75 0 0 1 19 20.75H4A1.75 1.75 0 0 1 2.25 19v-2ZM4 16.75a.25.25 0 0 0-.25.25v2c0 .138.112.25.25.25h15a.25.25 0 0 0 .25-.25v-2a.25.25 0 0 0-.25-.25H4Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M13.629 3.363c.3-.058.605.013.856.2.72.536 2.352 2.105 3.438 3.177.55.544.591 1.413.108 2.008l-4.224 5.198a1.5 1.5 0 0 1-1.164.554h-2.74a1.5 1.5 0 0 1-.977-.361l-1.83-1.57a1.5 1.5 0 0 1-.14-2.142l6.013-6.68a1.2 1.2 0 0 1 .66-.384Zm.24 1.626-5.797 6.442L9.902 13h2.741l4.222-5.196c-.974-.962-2.271-2.208-2.996-2.815Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorVotingVoucher;
